<template>
  <section class="hero">
    <h1>Contact Us</h1>
  </section>

  <section class="contact-section">
    <h2 class="section-title">Get In Touch with Us</h2>
    <div class="divider"></div>

    <div class="contact-container">
      <!-- Left: Info Cards -->
      <div class="info-cards">
        <div class="info-card">
          <h3>Main Office</h3>
          <p>
            <strong>Seoul, Korea</strong><br />
            가산디지털2로 108, 905호
          </p>
        </div>

        <div class="info-card">
          <h3>Make A Call</h3>
          <p>
            <strong>070-4489-7241</strong><br />
            FAX : 02-420-7243
          </p>
        </div>

        <div class="info-card">
          <h3>Follow Us</h3>
          <div class="social-placeholder"></div>
        </div>
      </div>

      <!-- Right: Contact Form -->
      <div class="contact-form">
        <form>
          <div class="form-group">
            <label>
              Name
              <span class="required">*</span>
            </label>
            <input type="text" placeholder="E.g. John" required />
          </div>

          <div class="form-group">
            <label>
              Email Address
              <span class="required">*</span>
            </label>
            <input type="email" placeholder="E.g. john@doe.com" required />
          </div>

          <div class="form-group">
            <label>
              Phone Number
            </label>
            <input type="tel" placeholder="E.g. +1 3004005000" />
          </div>

          <div class="form-group">
            <label>
              Message
            </label>
            <textarea
              v-model="message"
              placeholder="Enter your message..."
              rows="5"
              maxlength="180"
            ></textarea>
            <div class="char-count">
              {{ message.length }} / 180
            </div>
          </div>

          <div class="button-wrapper">
            <button class="btn">SEND MESSAGE</button>
          </div>
        </form>
      </div>
    </div>
  </section>
  <section class="kakaomap">
    <div>
      <h1>지도</h1>
      <KakaoMap/>
    </div>
  </section>
</template>


<script setup>
import KakaoMap from '@/components/kakaomap/KakaoMap.vue';
import { ref } from 'vue';

const message = ref('');
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&family=Jost:wght@400;700&display=swap");

body {
  margin: 0;
  font-family: "Jost", sans-serif;
  background-color: #fff;
  color: #333;
}

.kakaomap {
  display: flex;
  justify-content: center;
}

.hero {
  /* background: url('./your-hero-image.png') center center/cover no-repeat; */
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero h1 {
  font-family: "Montserrat", sans-serif;
  font-size: 40px;
  color: #000;
}

.contact-section {
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #30308a;
}

.divider {
  width: 60px;
  height: 4px;
  background-color: #000;
  margin: 20px 0;
}

.contact-container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.info-cards {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.info-card h3 {
  font-size: 20px;
  border-bottom: 1px solid #30308a;
  padding-bottom: 8px;
  margin-bottom: 15px;
  color: #30308a;
}

.info-card p {
  font-size: 14px;
  line-height: 1.6;
}

.social-placeholder {
  width: 30px;
  height: 30px;
  background-color: #ccc;
  border-radius: 4px;
}

.contact-form {
  flex: 1;
}

.contact-form form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group label {
  display: block;
  font-weight: 700;
  margin-bottom: 8px;
  color: #777771;
}

.required {
  color: #e04562;
}


.char-count {
  text-align: right;
  font-size: 12px;
  color: #777;
  margin-top: 4px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #eaebf1;
  font-size: 14px;
  color: #333;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #999;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.button-wrapper {
  text-align: left; /* 버튼을 왼쪽 정렬 */
}

.btn {
  background-color: #6528f7;
  color: #ffffff;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  font-family: Arial, sans-serif;
}


</style>
